Flup.init(function (flup) {
    const $agentCountryRadio = $("[name='agent_country']");
    const $agentSelectorWrapper = $(".agent-selector-wrapper");
    const $agentSelector = $(".agent-selector");
    const $optGroups = {};
    $agentSelector.find("[data-country-code]").each(function () {
        $optGroups[$(this).data("country-code")] = $(this).remove();
    });
    const $addAgentButton = $("#add-agent-button");
    const $viewAgentButton = $("#view-agent-button");
    const $addAgentContainer = $(".add-agent-container");
    const $addAgentInput = $(".add_agent_input");
    const $addAgentButtonLabel = $(".add-agent-button-label");
    const $newAgentsOptionsContainer = $(".new-agent-options");
    const $viewAgentsOptionsContainer = $(".view-agents-options");
    const $saveNewAgentButton = $("#save-new-agent-button")
    $saveNewAgentButton.html(`<span class="icon-floppy"></span>`)
    let canInsertAgent = true

    $agentSelector.hide();
    $addAgentButton.hide();
    $addAgentButtonLabel.hide();
    $addAgentContainer.hide();
    $newAgentsOptionsContainer.hide();

    const toggleAgentOptions = () => {
        $newAgentsOptionsContainer.toggle($addAgentContainer.is(":visible"));
        $viewAgentsOptionsContainer.toggle(!$addAgentContainer.is(":visible"));
    }

    function onChange(val) {
        var showIt = val && !!val.length;
        showIt = !!showIt;

        $agentSelectorWrapper.toggle(showIt);
        $addAgentButton.toggle(showIt);
        $addAgentContainer.toggle(!showIt);
        $addAgentInput.val("");
        $addAgentButtonLabel.show();
        
        if (!val.length) $addAgentContainer.hide();
        if (!showIt) return;
        $agentSelector.find("optgroup").remove();
        $newAgentsOptionsContainer.hide();
        $viewAgentsOptionsContainer.show()
        resetAddAgent()
        $agentSelector.append($optGroups[val]).val("").select2();
    }

    const handleOptionButtonToggler = () => {
        $agentSelectorWrapper.toggle();
        $addAgentContainer.toggle();
        $agentSelector.val(null).trigger("change");
        $addAgentInput.val("");
        $addAgentButtonLabel.toggle($addAgentContainer.is(":visible"));
        toggleAgentOptions()
    }

    const resetAddAgent = () => {
        canInsertAgent = true
        $addAgentInput.prop('readonly', !canInsertAgent)
        $saveNewAgentButton.addClass("can-insert")
        $addAgentInput.removeClass("disable-writing")
        $saveNewAgentButton.html(`<span class="icon-floppy"></span>`)
    }

    $agentCountryRadio.change(function (e) {
        var val = $(this).val();
        onChange(val);
    });

    $addAgentButton.click(function (e) {
        e.preventDefault();
        handleOptionButtonToggler()
    });

    $viewAgentButton.click(function(e) {
        e.preventDefault();
        resetAddAgent()
        handleOptionButtonToggler()
    })

    $saveNewAgentButton.click(function(e){
        e.preventDefault();
        if ($addAgentInput.val().length == 0) return
        canInsertAgent = !canInsertAgent
        $addAgentInput.prop('readonly', !canInsertAgent)
        $saveNewAgentButton.toggleClass("can-insert")
        $addAgentInput.toggleClass("disable-writing")
        canInsertAgent ? $saveNewAgentButton.html(`<span class="icon-floppy"></span>`) : $saveNewAgentButton.html(`<span class="icon-pencil"></span>`)
    })

});
